import { defineStore } from "pinia";
import { Message } from "./Message";

const assistantLoading: Message = {
  type: "assistant-loading",
};

export const messageStore = defineStore("messageStore", {
  state: () => ({
    messages: [] as Message[],
  }),
  actions: {
    addMessage(message: Message) {
      if (message.type === "user") {
        this.messages.push(message);
        if (!message.hideForUser) {
          this.messages.push(assistantLoading);
        }
      } else if (message.type === "assistant") {
        const messagesTemp = this.messages.filter((el) => {
          return el.type !== "assistant-loading";
        });
        messagesTemp.push(message);

        this.messages = messagesTemp;
      }
    },
    addMessages(messages: Message[]) {
      for (const msg of messages) {
        this.addMessage(msg);
      }
    },
    clearMessages() {
      this.messages = [];
    },
  },
  getters: {
    getMessages(): Message[] {
      return this.messages;
    },
  },
});
